import React from "react";
import "firebase/firestore";
import "firebase/database";
import { Context } from "../backend/context";

import { Link } from "react-router-dom";
import { Redirect } from "react-router";

function SendTip() {
  const { uid, isLoggedIn } = React.useContext(Context);

  return (
    <div className="py-5 container text-left badge-dark">
      {!isLoggedIn || !uid ? <Redirect to="/" /> : null}
      <div className="row">
        <div className="col-11 col-sm-8 m-auto">
          <div className="row">
            <div className="col-12 h3 p-3 text-center">Send a Tip</div>
          </div>
        </div>{" "}
      </div>
      <div className="row ">
        <div className="col-11 m-auto h6 text-center">
          If you love these cloud bots consider small donations for maintenance
          and updates.
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6 col-12 mt-3">
          <div className="row">
            <div className="col-8 text-center m-auto">
              <img
                src="/img/Neo_QR.png"
                alt="neo wallet"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 h7 text-center pt-2">NEO Wallet Address</div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              AVXCkwFnARDnFLkSvzbTsHVuzFGkk9Dxmq
            </div>
          </div>
        </div>{" "}
        <div className="col-sm-6 col-12 mt-3">
          <div className="row">
            <div className="col-8 text-center m-auto">
              <img
                src="/img/Ethereum_QR.png"
                alt="eth wallet"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 h7 text-center pt-2">ETH Wallet Address</div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              0x3612d06dF9B8521705dcF05561cd403FaaEa64Af
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-sm-6 col-12 m-auto text-center">
          <Link to="/account" className="btn btn-secondary px-3 w-50">
            Back
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SendTip;
